import { createSelector } from 'reselect';
import { getSourceSetModels } from '../../../pages/discovery/selectors';

export const getAlertSettingsSourceSetModel = createSelector(
    [getSourceSetModels],
    (models) => models.alertSettings || null
);
